export const STATIC_ROUTES = {
  SELECT_ACCOUNT: '/select-account',
  REPORTS: '/reports',
  REPORTS_REPORT_BUILDER: '/reports/custom',
  REPORTS_STATISTICS: '/reports/statistics',
  CORPORATE_LIBRARY: '/corporate-library',
  // CNA
  CNA: '/cna',
  CNA_ASSIGNMENTS: '/cna/assignments',
  CNA_ASSIGNMENTS_MOBILE: '/cna/assignments/mobile',
  CNA_DEFAULT_TASKS: '/cna/default-tasks',
  TASKS: '/tasks',
  SCHEDULE: '/schedule',
  BEDBOARD: '/bedboard',
  SCHEDULING: '/scheduling',
  PICKUP_SHIFT: '/pickup-shift',
  MASTER_SCHEDULE: '/master-schedule',
  MY_SHIFTS: '/my-shifts',
  GENERAL_USERS: '/general-users',
  GENERAL_USERS_DETAIL: '/general-users/:id',
  PHONES_MODULE: '/company/:companyId/phones',
};
